import { useMemo } from 'react';
import type { DataTableRenderCellParams as GridRenderCellParams } from '@/components/custom/erp';
import type { BaoCaoSoDuQuyVaNganHangRow } from '@/types/schemas';
import { TableData } from '@/components/custom/erp';

export interface UseTableDataReturn {
  tables: TableData[];
}

export function useTableData(data: BaoCaoSoDuQuyVaNganHangRow[]): UseTableDataReturn {
  const tables = useMemo(() => {
    const tableData: TableData[] = [
      {
        name: '',
        columns: [
          {
            field: 'tk',
            headerName: 'Tài khoản',
            width: 100,
            renderCell: (params: GridRenderCellParams<BaoCaoSoDuQuyVaNganHangRow>) => {
              return params.row.tk_data?.code || '';
            }
          },
          {
            field: 'ten_tk',
            headerName: 'Tên tài khoản',
            width: 100,
            renderCell: (params: GridRenderCellParams<BaoCaoSoDuQuyVaNganHangRow>) => {
              return params.row.tk_data?.name || '';
            }
          },
          {
            field: 'du',
            headerName: 'Dư',
            width: 100
          },
          {
            field: 'du_nt',
            headerName: 'Dư nt',
            width: 100
          }
        ],
        rows: data
      }
    ];

    return tableData;
  }, [data]);

  return {
    tables
  };
}
